import {CustomContainerStyles, ModalStyleType} from '@stencil/hotels-types';

// Define style map for different conditions
export const styleMap = {
  [ModalStyleType.Default]: {
    customContainerStyles: {
      container: {},
      content: {},
      contentWrapper: {
        borderRadius: '24px 24px 0px 0px',
      },
    },
  },
  [ModalStyleType.Floating]: {
    customContainerStyles: {
      container: {
        padding: '0 12px 20px',
      },
      content: {
        overflow: 'initial',
        background: 'none',
      },
      contentWrapper: {
        borderRadius: '20px',
      },
      close: {
        width: '2rem',
        height: '2rem',
        background: '#a7a7a7',
        borderRadius: '50%',
      },
      closeBeforeAfterStyles: {
        width: '0.2rem',
        height: '1.2rem',
        background: '#fff',
        content: '',
        position: 'absolute',
        top: '0.4rem',
        right: '0.85rem',
      },
    },
  },
};

// Helper function to merge styles
export const mergeStyles = (baseStyles = {}, overrideStyles = {}) => {
  const mergedStyles = {} as CustomContainerStyles;

  const allKeys = new Set([...Object.keys(baseStyles), ...Object.keys(overrideStyles)]);

  allKeys.forEach(key => {
    mergedStyles[key] = {
      ...baseStyles[key],
      ...overrideStyles[key],
    };
  });

  return mergedStyles;
};
